import { Badge, IconButton, Td, Tr } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { useContext, useState } from "react";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import AddDrawItem from "../AddDrawItem";
import { LoanContext } from "providers/loan";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useMemo } from "react";
import { permissionConstants, hasPermission } from "utils/permissionHelper";
import { useCustomFormats } from "hooks/useCustomFormat";

const statusBadgeColors: {
  [key: string]: string;
} = {
  unpaid: "#9E9AA3",
  pending: "#F2B821",
  declined: "#FF2E2E",
  approved: "#45C14A",
  paid: "#59DB1C",
};

const ScheduleSection = ({ section, items }: { section: number; items: any[] }) => {
  const { formatDate, formatCurrency } = useCustomFormats();
  const location = useLocation();
  let params = useMemo(() => new URLSearchParams(location.search), [location.search]);

  const { user } = useTenant();
  const { setDrawRequest } = useContext(LoanContext);
  const [readLoan, setReadLoan] = useState(false);

  useEffect(() => {
    items.forEach(item => {
      if (item.id.toString() === params.get("draw_request")) {
        setDrawRequest(item);
      }
    });
  }, []);

  const readOnlyLoan = () => {
    if (hasPermission(user, permissionConstants.readOnlyLoans)) {
      setReadLoan(true);
    }
    if (hasPermission(user, permissionConstants.viewPayments)) {
      setReadLoan(false);
    }
  };

  useEffect(() => {
    readOnlyLoan();
  }, []);

  function ordinal_suffix_of(i: number) {
    let j = i % 10,
      k = i % 100;
    if (j === 1 && k !== 11) {
      return i + "st";
    }
    if (j === 2 && k !== 12) {
      return i + "nd";
    }
    if (j === 3 && k !== 13) {
      return i + "rd";
    }
    return i + "th";
  }

  const getDistributionIndex = (sectionIndex: number) => {
    return `${ordinal_suffix_of(sectionIndex + 1)} Distribution `;
  };

  return (
    <>
      <Tr bg="gray.25">
        <Td fontWeight="600" fontSize="15px" color="black" colSpan={3} pl={3}>
          {getDistributionIndex(section)}
        </Td>
        <Td isNumeric fontSize="16px" color="secondary">
          {formatCurrency(items.reduce((prev, curr) => (prev += curr.amount), 0))}
        </Td>
        <Td></Td>
      </Tr>
      {items
        .sort(
          (a, b) =>
            moment(a.due_date, "YYYY-MM-DD").valueOf() - moment(b.due_date, "YYYY-MM-DD").valueOf()
        )
        .map(item => (
          <Tr key={item.id}>
            <Td>{item.title}</Td>
            <Td>
              <Badge bg="#601DCB15" color="#601DCB" fontWeight="600" fontSize="12px">
                {formatDate(item.due_date, "DD/MM/YY")}
              </Badge>
            </Td>
            <Td>
              <Badge
                bg={`${statusBadgeColors[item.status]}15`}
                color={statusBadgeColors[item.status]}
                fontWeight="600"
                fontSize="12px"
                textTransform="capitalize"
              >
                {item.status}
              </Badge>
            </Td>
            <Td isNumeric>{formatCurrency(item.amount)}</Td>
            <Td isNumeric>
              <IconButton
                w="18px"
                h="18px"
                variant="ghost"
                aria-label="draw-request"
                borderColor="primary"
                onClick={() => setDrawRequest(item)}
                isDisabled={readLoan}
                icon={
                  <>
                    <FontAwesomeIcon icon={["fas", "right-from-bracket"]} />
                  </>
                }
              />
            </Td>
          </Tr>
        ))}
      {user.type === "lender" && <AddDrawItem section={section} />}
    </>
  );
};

export default ScheduleSection;
